import { IconButton } from '@chakra-ui/react';
import { faShoppingCart } from '@fortawesome/pro-solid-svg-icons';
import { FaIcon } from '@ifixit/icons';
import { BlueDot } from '../../misc';

interface CartDrawerTriggerProps {
   onClick?: () => void;
   hasItemsInCart?: boolean;
}

export function CartDrawerTrigger({ onClick, hasItemsInCart }: CartDrawerTriggerProps) {
   return (
      <div className="relative">
         <IconButton
            aria-label="Open cart"
            variant="ghost"
            transition="0.3s"
            className="hover:opacity-70"
            display="flex"
            icon={<FaIcon icon={faShoppingCart} h={6} color="white" />}
            onClick={onClick}
            _hover={{
               bg: 'none',
            }}
            data-testid="cart-drawer-open"
            border="0"
         />
         {hasItemsInCart && <BlueDot position="absolute" top="2px" right="2px" />}
      </div>
   );
}
